// extracted by mini-css-extract-plugin
module.exports = {"card":"StatusBlock_card__1-M3K"};